export enum APP {
  MY_CLEANINGS = "MyCleanings",
  BOOKING = "Booking",
  HC_BOOKING_ZIP_INPUT = "homeCleaningPostalInput",
  END_OF_TENANCY = "EndOfTenancy",
  B2B = "B2B",
  PAYMENT_PROCESSED = "PaymentProcessed",
  APPLY = "Apply",
  LANDING_PAGE = "LandingPage",
  SUPPORT = "Support",
  ONBOARDING = "Onboarding",
}

export enum HOMEPAGE {
  LETS_GO_BTN = "letsGoButton",
  ZIP_INPUT = "zipInput",
  HERO_NAV_ITEM = "heroNavItem",
  VIDEO_SECTION = "videoSection",
  FOOTER_CONTACT = "footerContactList",
  FOOTER_NAVIGATION = "footerNavigation",
  FOOTER_SOCIAL = "footerSocial",
}

export enum HOMEPAGE_V2 {
  LETS_GO_BTN = "letsGoButton",
  HERO_SERVICES_DROPDOWN = "servicesDropdown",
  HERO_SERVICE_OPTION = "heroServiceOption",
  ZIP_INPUT = "zipInput",
  EXTRAS_HOME_CLEANING = "extrasHomeCleaning",
  EXTRAS_END_OF_TENANCY = "extrasEndOfTenancy",
  EXTRAS_BUSINESS_CLEANING = "extrasBusinessCleaning",
  SERVICES_B2C = "servicesB2c",
  SERVICES_EOT = "servicesEot",
  SERVICES_B2B = "servicesB2b",
  SERVICES_CLEANING_PRODUCTS = "servicesCleaningProducts",
  BOOK_YOUR_CLEANING_BTN = "bookYourCleaningButton",
  BECOME_BATMAID_BTN = "becomeBatmaidButton",
}
